// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBQmduf2OYtPZuR2c901lvHFUzNITshF1Q",
  authDomain: "cinevest-51466.firebaseapp.com",
  projectId: "cinevest-51466",
  storageBucket: "cinevest-51466.firebasestorage.app",
  messagingSenderId: "792200772097",
  appId: "1:792200772097:web:434de4ce8694d01beade00"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, app, storage };
